import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { SugarCookerContinuous } from "./modelSugarCookerContinuous";

class ControllerSugarCookerContinuous extends ControllerModel {
    constructor() {
        super("ControllerSugarCookerContinuous");

        this.setNewNode = (callback) => {
            let sugarCookerContinuous = new SugarCookerContinuous();
            sugarCookerContinuous.decorate(callback);

            this.addNode(sugarCookerContinuous);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let sugarCookerContinuous = new SugarCookerContinuous();
            sugarCookerContinuous.copyFrom(node);
            sugarCookerContinuous.decorate(callback);
            this.addNode(sugarCookerContinuous)
        }

        this.getProperties = async (node) => {
            let n = new SugarCookerContinuous();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new SugarCookerContinuous();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerSugarCookerContinuous };